// src/components/LanguageSelect.jsx
import { useTranslation } from 'react-i18next';
import { LANGUAGES, setLanguage } from '../i18n';

export default function LanguageSelect({ compact = false, label }) {
  const { i18n } = useTranslation();
  const current = i18n.language;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
      {label && (
        <label style={{
          fontSize: 11, fontWeight: 700,
          color: 'var(--fg-muted)', letterSpacing: '0.06em',
          textTransform: 'uppercase',
        }}>
          {label}
        </label>
      )}
      <select
        value={current}
        onChange={e => setLanguage(e.target.value)}
        className="select"
        style={compact ? { fontSize: 13, padding: '8px 10px' } : {}}
      >
        {LANGUAGES.map(l => (
          <option key={l.code} value={l.code}>
            {l.flag} {l.name}
          </option>
        ))}
      </select>
    </div>
  );
}
